import React, { useEffect, useRef, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Tabs from '../../components/ServiceComponent/Tabs';
import { FileUploader } from 'react-drag-drop-files';
import {
	incomeTaxInitial,
	serviceInitial,
	incomeTaxInitialFile,
	name_re,
	mobile_re,
	email_re,
	baseVar,
} from '../../Global/GlobalVariable';
import { toast } from 'react-toastify';
import upload_icon from '../../assets/file_before_upload.svg';
import uploaded_icon from '../../assets/uploaded_icon.svg';
import delete_icon from '../../assets/delete_icon.svg';
import Modal from 'react-modal';
import { MdOutlineClose } from 'react-icons/md';
import axios from 'axios';
import { baseUrl } from '../../Global/GlobalVariable';
import { useNavigate } from 'react-router-dom';
import ServiceSuccess from '../../components/popup/serviceFormRegister/ServiceFormRegister';
import $ from 'jquery';

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		maxWidth: '90%',
		borderRadius: '20px',
		maxHeight: '90vh',
		overflow: 'hidden',
		padding: '0px 3px 0px 6px',
		width: '90%',
	},
};

function ServiceContent({ data, id }) {
	const [datas, setDatas] = useState([]);
	const [service, setServicePage] = useState();
	const [fromValue, setFromValue] = useState(serviceInitial);
	const [fromFile, setFromFile] = useState(incomeTaxInitialFile);
	const [nameErr, setNameErr] = useState();
	const [mobErr, setMobErr] = useState();
	const [emailErr, setEmailErr] = useState();
	const [imageErr, setImageErr] = useState();
	const [modalIsOpen, setIsOpen] = useState(false);
	const [url, setUrl] = useState('');
	const [href, setHref] = useState('');
	const [serviceSuccess, setServiceSuccess] = useState(false);

	const formRef = useRef(null);

	var button = document.getElementById('atag');

	const navigateFn = () => {
		navigate('/acknowledgement');
	};

	const navigate = useNavigate();

	const serviceModel = () => {
		setIsOpen(true);
	};

	function closeModal() {
		setIsOpen(false);
	}

	useEffect(() => {
		const serviceIncome = () => {
			if (id === 'income-tax-returns-filing') {
				setFromValue(incomeTaxInitial);
				setServicePage(false);
			} else {
				setServicePage(true);
				setFromValue(serviceInitial);
			}
		};
		serviceIncome();
	}, [data]);

	useEffect(() => {
		if (data) {
			setDatas(data);
			setFromValue({ ...fromValue, url: id });
			setUrl(fromValue.url);
		}
	}, [data, service]);

	const handleChange = (event) => {
		if (event.target.name === 'name') {
			let validName = name_re.test(event.target.value);
			if (!validName) {
				setNameErr(true);
			} else {
				setFromValue({ ...fromValue, name: event.target.value });
				setNameErr(false);
			}
		}
		if (event.target.name === 'mobileNumber') {
			let validNumber = mobile_re.test(event.target.value);
			if (!validNumber) {
				setMobErr(true);
			} else {
				setFromValue({ ...fromValue, mobile: event.target.value });
				setMobErr(false);
			}
		}
		if (event.target.name === 'email') {
			let validEmail = email_re.test(event.target.value);
			if (!validEmail) {
				setEmailErr(true);
			} else {
				setFromValue({ ...fromValue, email: event.target.value });
				setEmailErr(false);
			}
		}
	};

	// File

	const fileTypes = ['JPEG', 'PDF', 'JPG'];

	const [file, setFile] = useState('');

	let formData = new FormData();

	const handleChanges = (file) => {
		setFile(file);
		if (file) {
			setFromFile({ file: file });
			toast.info('File uploaded Successfully');
			setImageErr(false);
			if (!imageErr) {
			}
		} else {
			setImageErr(true);
			setFromFile({ file: '' });
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		if (service === true) {
			if (
				nameErr === false &&
				mobErr === false &&
				emailErr === false &&
				!imageErr
			) {
				formData.append('url', url);
				formData.append('name', fromValue?.name);
				formData.append('mobile', fromValue?.mobile);
				formData.append('email', fromValue?.email);

				const serviceFormApi = async () => {
					await axios
						.post(`${baseUrl}/serviceEnquiry`, formData)
						.then((res) => {
							if (res.data.status === '1') {
								setHref(res.data);
								toast.success('Thank you for submitting the form');
								button.click();
								serviceSuccesss();
								formRef.current.reset();
								setNameErr();

								// setTimeout(navigateFn, 3000);
							} else {
								toast.warn(res.data.message);
							}
						});
				};
				serviceFormApi();
			} else {
				toast.warn('Please ensure that all required fields are completed');
			}
		}
		if (service === false) {
			if (
				nameErr === false &&
				mobErr === false &&
				emailErr === false &&
				imageErr === false
			) {
				if (service === false) {
					formData.append('file', fromFile.file);
					formData.append('url', url);
					formData.append('name', fromValue?.name);
					formData.append('mobile', fromValue?.mobile);
					formData.append('email', fromValue?.email);
				}

				const serviceFormApi = async () => {
					await axios
						.post(`${baseUrl}/serviceEnquiry`, formData)
						.then((res) => {
							if (res.data.status === '1') {
								toast.success('Thank you for submitting the form');
								button.click();
								// setTimeout(navigateFn, 3000);
								serviceSuccesss();
								formRef.current.reset();
								setNameErr();

								formRef.current.reset();
							} else {
								toast.warn(res.data.message);
							}
						});
				};
				serviceFormApi();
			} else {
				toast.warn('Please ensure that all required fields are completed');
			}
		}
	};

	const serviceSuccesss = () => {
		if (!serviceSuccess) {
			setServiceSuccess(false <= true);
		} else {
			setServiceSuccess(true <= false);
		}
	};

	useEffect(() => {}, [file]);

	$('.popup_model_onScrollsc').addClass('popup_model_onScroll_bgsc');
	const scrollFn = () => {
		$('.popup_model_onScrollsc').removeClass('popup_model_onScroll_bgsc');
		setTimeout(fadeInFn, 1000);
	};
	const fadeInFn = () => {
		$('.popup_model_onScrollsc').addClass('popup_model_onScroll_bgsc');
	};
	return (
		<div className='fade_in'>
			<a
				rel='nofollow'
				title='atag'
				id='atag'
				href={`${baseUrl}/file-download/${url}`}
			/>
			{service && (
				<Row>
					<Col sm={12} lg={9}>
						<Row>
							{data?.require_list_active?.map((res, i) => {
								return (
									<Col key={i} sm={12} md={6} lg={4}>
										<div className=' text-start'>
											<div>
												<div className='cs_c1_C1_1 py-1 p-0 '>
													<p className='cs_c1_c1_p1 py-2 mx-3 mb-0'>
														{res.require_list}
													</p>
												</div>
												<div className='mt-lg-4 mt-md-3 mt-2 pt-1'>
													<ul>
														{res?.req_det_active?.map((res, i) => {
															return (
																<li key={i} className='my-2 c1_c1_p2 ms-2'>
																	{res.require_details}
																</li>
															);
														})}
													</ul>
												</div>
											</div>
										</div>
									</Col>
								);
							})}
							{data?.require_title_active == null &&
								data.tile_title_active !== null && (
									<Col md={6}>
										<div className=' text-start'>
											<div>
												<div className='cs_c1_C1_1 py-1 p-0 '>
													<p className='cs_c1_c1_p1 py-2 mx-3 mb-0'>
														{data?.tile_title_active?.tile_title}
													</p>
												</div>
												<div className='mt-lg-4 mt-md-3 mt-2 pt-1'>
													<ul>
														{data?.tile_details_active?.map((res, i) => {
															return (
																<li
																	key={i}
																	className='my-2 c1_c1_p2_custom ms-2'>
																	{res.tile_name}
																</li>
															);
														})}
													</ul>
												</div>
											</div>
										</div>
									</Col>
								)}
							<Col
								sm={12}
								md={10}
								lg={3}
								className=' d-flex justify-content-end'>
								<div className='form_container d-none  d-md-block d-lg-none mt-4 '>
									<p className='s_popup_headTx'>Get In Touch</p>
									<form ref={formRef} onSubmit={handleSubmit}>
										<div>
											<label
												htmlFor='name'
												className='d-block text-start c1_c1_label mb-2 '>
												Full Name<span className='text-danger '>*</span>
											</label>
											<input
												id='name'
												className='w-100 py-2 c1_c1_input'
												type='text'
												name='name'
												onChange={handleChange}
												placeholder='Enter Full Name'
											/>
											{nameErr && (
												<p className='text-danger  text-start errMsg mt-2'>
													Enter Valid Name
												</p>
											)}
										</div>
										<div>
											<label
												htmlFor='mobileNumber'
												className='d-block text-start c1_c1_label mb-2 mt-4'>
												Mobile Number<span className='text-danger '>*</span>
											</label>
											<input
												id='mobileNumber'
												className='w-100 py-2 c1_c1_input'
												type='text'
												maxLength='10'
												onChange={handleChange}
												name='mobileNumber'
												placeholder='Enter Your Mobile Number'
											/>
											{mobErr && (
												<p className='text-danger text-start errMsg mt-2'>
													Enter Valid Mobile Number
												</p>
											)}
										</div>
										<div>
											<label
												htmlFor='email'
												className='d-block text-start c1_c1_label mb-2 mt-4'>
												Email<span className='text-danger '>*</span>
											</label>
											<input
												id='email'
												className='w-100 py-2 c1_c1_input'
												type='email'
												onChange={handleChange}
												name='email'
												placeholder='Enter Your Email ID'
											/>
											{emailErr && (
												<p className='text-danger text-start mb-0 errMsg mt-2'>
													Enter Valid Email
												</p>
											)}
										</div>
										<div className='d-flex  justify-content-center'>
											<button
												className='my-4  w-100 mb-lg-3 mt-4 c1_c1_btn'
												type='submit'>
												Download Quote
											</button>
										</div>
									</form>
								</div>
							</Col>
							<Col
								sm={12}
								lg={4}
								className='d-block d-lg-none d-flex justify-content-center'>
								{' '}
								<Modal
									isOpen={modalIsOpen}
									onRequestClose={closeModal}
									style={customStyles}
									contentLabel='Example Modal'
									className=''>
									<div
										className='popup_model_onScrollsc popup_model_onScroll_bgsc fade_in'
										onScroll={scrollFn}>
										<div className='d-flex align-items-center justify-content-between'>
											<p className='s_popup_headTx'>Get In Touch</p>
											<button
												onClick={closeModal}
												className='border-0 bg-white text-right w-25 mb-2'>
												<p
													className='display-6 fw-2 mt-0 text-end'
													style={{
														fontWeight: '500',
														color: '#3C3C3C',
														fontSize: '30px',
														opacity: '0.8',
													}}>
													<MdOutlineClose />
												</p>
											</button>
										</div>
										<div className='form_container '>
											<form ref={formRef} onSubmit={handleSubmit}>
												<div>
													<label
														htmlFor='name'
														className='d-block text-start c1_c1_label mb-2 '>
														Full Name<span className='text-danger '>*</span>
													</label>
													<input
														id='name'
														className='w-100 py-2 c1_c1_input'
														type='text'
														name='name'
														onChange={handleChange}
														placeholder='Enter Full Name'
													/>
													{nameErr && (
														<p className='text-danger text-start errMsg mt-2'>
															Enter Valid Name
														</p>
													)}
												</div>
												<div>
													<label
														htmlFor='mobileNumber'
														className='d-block text-start c1_c1_label mb-2 mt-4'>
														Mobile Number<span className='text-danger '>*</span>
													</label>
													<input
														id='mobileNumber'
														className='w-100 py-2 c1_c1_input'
														type='text'
														maxLength='10'
														onChange={handleChange}
														name='mobileNumber'
														placeholder='Enter Your Mobile Number'
													/>
													{mobErr && (
														<p className='text-danger text-start errMsg mt-2'>
															Enter Valid Mobile Number
														</p>
													)}
												</div>
												<div>
													<label
														htmlFor='email'
														className='d-block text-start c1_c1_label mb-2 mt-4'>
														Email<span className='text-danger '>*</span>
													</label>
													<input
														id='email'
														className='w-100 py-2 c1_c1_input'
														type='email'
														onChange={handleChange}
														name='email'
														placeholder='Enter Your Email ID'
													/>
													{emailErr && (
														<p className='text-danger text-start errMsg mt-2 mb-0'>
															Enter Valid Email
														</p>
													)}
												</div>
												<div className='d-flex  justify-content-center'>
													<button
														className='my-4  w-100 mb-lg-3 mt-4 c1_c1_btn'
														type='submit'>
														Download Quote
													</button>
												</div>
											</form>
										</div>
									</div>
								</Modal>
								<div className='w-100 download_qt d-block d-md-none d-lg-none'>
									<button
										className='my-4  w-75 mb-lg-3 mt-4 c1_c1_btn'
										onClick={serviceModel}>
										Download Quote
									</button>
								</div>
							</Col>
							<Col sm={12} lg={12}>
								<div className='mt-5 pt-lg-5'>
									<div>
										<p className=' c1_c1_h1 mb-3 mb-lg-4 text-start'>
											Things to know
										</p>
									</div>
									<Tabs />
								</div>
							</Col>
						</Row>
					</Col>

					<Col sm={12} lg={3} className=' d-flex justify-content-end'>
						<div className='form_container d-none  d-lg-block '>
							<div className='d-flex align-items-center'>
								<p className='s_popup_headTx'>Get In Touch</p>
								<button
									onClick={closeModal}
									className='border-0 bg-white text-rigth w-25 mb-2'></button>
							</div>
							<form ref={formRef} onSubmit={handleSubmit}>
								<div>
									<label
										htmlFor='name'
										className='d-block text-start c1_c1_label mb-2 '>
										Full Name<span className='text-danger '>*</span>
									</label>
									<input
										id='name'
										className='w-100 py-2 c1_c1_input'
										type='text'
										name='name'
										onChange={handleChange}
										placeholder='Enter Full Name'
									/>
									{nameErr && (
										<p className='text-danger  text-start errMsg mt-2'>
											Enter Valid Name
										</p>
									)}
								</div>
								<div>
									<label
										htmlFor='mobileNumber'
										className='d-block text-start c1_c1_label mb-2 mt-4'>
										Mobile Number<span className='text-danger '>*</span>
									</label>
									<input
										id='mobileNumber'
										className='w-100 py-2 c1_c1_input'
										type='text'
										maxLength='10'
										onChange={handleChange}
										name='mobileNumber'
										placeholder='Enter Your Mobile Number'
									/>
									{mobErr && (
										<p className='text-danger text-start errMsg mt-2'>
											Enter Valid Mobile Number
										</p>
									)}
								</div>
								<div>
									<label
										htmlFor='email'
										className='d-block text-start c1_c1_label mb-2 mt-4'>
										Email<span className='text-danger '>*</span>
									</label>
									<input
										id='email'
										className='w-100 py-2 c1_c1_input'
										type='email'
										onChange={handleChange}
										name='email'
										placeholder='Enter Your Email ID'
									/>
									{emailErr && (
										<p className='text-danger text-start mb-0 errMsg mt-2'>
											Enter Valid Email
										</p>
									)}
								</div>
								<div className='d-flex  justify-content-center'>
									<button
										className='my-4  w-100 mb-lg-3 mt-4 c1_c1_btn'
										type='submit'>
										Download Quote
									</button>
								</div>
							</form>
						</div>
					</Col>
				</Row>
			)}{' '}
			{!service && (
				// incometax service Form start
				<>
					<Row>
						<Col sm={12} lg={6} xl={6}>
							<Row>
								{data?.require_list_active?.map((res, i) => {
									return (
										<Col key={i} sm={12} md={6} lg={6}>
											<div className=' text-start'>
												<div>
													<div className='cs_c1_C1_1 py-1 p-0'>
														<p className='cs_c1_c1_p1 py-2 mx-3 mb-0'>
															{res.require_list}
														</p>
													</div>
													<div className='mt-lg-4 mt-md-3 mt-2 pt-1'>
														<ul>
															{res?.req_det_active?.map((res, i) => {
																return (
																	<li key={i} className='my-2 c1_c1_p2 ms-2'>
																		{res.require_details}
																	</li>
																);
															})}
														</ul>
													</div>
												</div>
											</div>
										</Col>
									);
								})}
								{data?.require_title_active == null &&
									data.tile_title_active !== null && (
										<Col md={10}>
											<div className=' text-start'>
												<div>
													<div className='cs_c1_C1_1 py-1 p-0 '>
														<p className='cs_c1_c1_p1 py-2 mx-3 mb-0'>
															{data?.tile_title_active?.tile_title}
														</p>
													</div>
													<div className='mt-lg-4 mt-md-3 mt-2 pt-1'>
														<ul>
															{data?.tile_details_active?.map((res, i) => {
																return (
																	<li
																		key={i}
																		className='my-2 c1_c1_p2_custom ms-2'>
																		{res.tile_name}
																	</li>
																);
															})}
														</ul>
													</div>
												</div>
											</div>
										</Col>
									)}

								<Col sm={12} lg={6} className='d-block d-lg-none'>
									<Modal
										isOpen={modalIsOpen}
										onRequestClose={closeModal}
										style={customStyles}
										contentLabel='Example Modal'
										className=''>
										{' '}
										<div
											className='popup_model_onScrollsc popup_model_onScroll_bgsc fade_in'
											onScroll={scrollFn}>
											<div className='d-flex align-items-center justify-content-between'>
												<p className='s_popup_headTx'>Get In Touch</p>
												<button
													onClick={closeModal}
													className='border-0 bg-white text-right w-25 mb-2'>
													<p
														className='display-6 fw-2 mt-0 text-end'
														style={{
															fontWeight: '500',
															color: '#3C3C3C',
															fontSize: '30px',
															opacity: '0.8',
														}}>
														<MdOutlineClose />
													</p>
												</button>
											</div>
											<form
												ref={formRef}
												className='d-flex justify-content-center'
												onSubmit={handleSubmit}>
												<div className=''>
													<div>
														<div
															style={{ padding: '0px !important' }}
															className='m_popup'>
															<FileUploader
																multiple={false}
																handleChange={handleChanges}
																name='file'
																types={fileTypes}>
																{file ? (
																	<div>
																		<img
																			src={uploaded_icon}
																			alt='icon'
																			title='icon'
																		/>

																		{/* <p className="form-file">
                                    File name: {file[0].name}
                                  </p> */}
																	</div>
																) : (
																	<div>
																		<img
																			src={upload_icon}
																			alt='icon'
																			title='icon'
																		/>
																	</div>
																)}
																<br />
																<p className='form-file  text-decoration-underline mt-0'>
																	Upload your form 16 document here
																</p>{' '}
															</FileUploader>
															{file && (
																<div
																	className='delete_control d-flex text-center justify-content-center mx-3'
																	onClick={() => {
																		setFile('');
																		setImageErr(true);
																		setFromFile({ file: '' });
																	}}
																	style={{ cursor: 'pointer' }}>
																	<p className=' mb-0 mx-3'>{file.name}</p>
																	<img
																		src={delete_icon}
																		alt='delete icon '></img>
																</div>
															)}
															<p className='learn_more_popup mb-0 mt-5'>
																Your information is safe with us{' '}
															</p>
															<a
																title='privacy-policy'
																className='popup_learn_more '
																href={baseVar + '/privacy-policy'}>
																Learn more
															</a>
														</div>
													</div>
													<div style={{ marginTop: '-50px' }}>
														<label
															htmlFor='name'
															className='d-block text-start c1_c1_label mb-2 mt-3'>
															Full Name<span className='text-danger '>*</span>
														</label>
														<input
															id='name'
															className='w-100 py-2 c1_c1_input'
															type='text'
															name='name'
															onChange={handleChange}
															placeholder='Enter Full Name'
														/>
														{nameErr && (
															<p className='text-danger text-start errMsg mt-2'>
																Enter Valid Name
															</p>
														)}
													</div>
													<div>
														<label
															htmlFor='mobileNumber'
															className='d-block text-start c1_c1_label mb-2 mt-4'>
															Mobile Number
															<span className='text-danger '>*</span>
														</label>
														<input
															id='mobileNumber'
															className='w-100 py-2 c1_c1_input'
															type='text'
															maxLength='10'
															onChange={handleChange}
															name='mobileNumber'
															placeholder='Enter Your Mobile Number'
														/>
														{mobErr && (
															<p className='text-danger text-start errMsg mt-2'>
																Enter Valid Mobile Number
															</p>
														)}
													</div>
													<div>
														<label
															htmlFor='email'
															className='d-block text-start c1_c1_label mb-2 mt-4'>
															Email<span className='text-danger '>*</span>
														</label>
														<input
															id='email'
															className='w-100 py-2 c1_c1_input'
															type='email'
															onChange={handleChange}
															name='email'
															placeholder='Enter Your Email ID'
														/>
														{emailErr && (
															<p className='text-danger text-start errMsg mt-2'>
																Enter Valid Email
															</p>
														)}
													</div>

													<div className='d-flex  justify-content-center'>
														<button
															className='my-4  w-100 mb-lg-3 mt-3 c1_c1_btn'
															type='submit'>
															File IT Return
														</button>
													</div>
												</div>
											</form>
										</div>
									</Modal>{' '}
									<div className='w-100 download_qt d-block d-md-none d-lg-none'>
										<button
											className='my-4  w-75 mb-lg-3 mt-4 c1_c1_btn'
											onClick={serviceModel}>
											File IT Return
										</button>
									</div>
								</Col>
							</Row>
						</Col>

						<Col
							sm={12}
							lg={6}
							xl={6}
							className=' d-flex justify-content-end ps-lg-2 ps-xl-5 mt-md-5 ps-md-0 mt-lg-0'>
							<div className='form_container w-100 d-none d-md-block d-lg-block  ms-2'>
								<div className='d-flex align-items-center'>
									<p className='s_popup_headTx text-start'>Get In Touch</p>
								</div>
								<form
									ref={formRef}
									className='d-flex justify-content-center'
									onSubmit={handleSubmit}>
									{/* file uploader */}
									<div className='pe-5 mt-0'>
										<FileUploader
											multiple={false}
											handleChange={handleChanges}
											name='file'
											types={fileTypes}>
											{file ? (
												<div className='mt-5'>
													<img src={uploaded_icon} alt='icon' title='icon' />
												</div>
											) : (
												<div className='mt-5'>
													<img src={upload_icon} alt='icon' title='icon' />
												</div>
											)}
											<p className='form-file text-decoration-underline mt-3'>
												Upload your form 16 document here
											</p>

											<br />
										</FileUploader>
										{file && (
											<div
												className='delete_control d-flex text-center justify-content-center mx-3'
												onClick={() => {
													setFile('');
													setImageErr(true);
													setFromFile({ file: '' });
												}}
												style={{ cursor: 'pointer' }}>
												<p className=' mb-0 mx-3'>{file.name}</p>
												<img src={delete_icon} alt='delete icon '></img>
											</div>
										)}
										<p className='learn_more  mb-0'>
											Your information is safe with us
										</p>
										<a
											title='learn_more'
											className='learn_more '
											href={baseVar + '/privacy-policy'}>
											Learn more
										</a>
									</div>
									<div className='sp_form'>
										<div>
											<label
												htmlFor='name'
												className='d-block text-start c1_c1_label mb-2 '>
												Full Name<span className='text-danger '>*</span>
											</label>
											<input
												id='name'
												className='w-100 py-2 c1_c1_input'
												type='text'
												name='name'
												onChange={handleChange}
												placeholder='Enter Full Name'
											/>
											{nameErr && (
												<p className='text-danger text-start errMsg mt-2'>
													Enter Valid Name
												</p>
											)}
										</div>
										<div>
											<label
												htmlFor='mobileNumber'
												className='d-block text-start c1_c1_label mb-2 mt-4'>
												Mobile Number<span className='text-danger '>*</span>
											</label>
											<input
												id='mobileNumber'
												className='w-100 py-2 c1_c1_input'
												type='text'
												maxLength='10'
												onChange={handleChange}
												name='mobileNumber'
												placeholder='Enter Your Mobile Number'
											/>
											{mobErr && (
												<p className='text-danger text-start errMsg mt-2'>
													Enter Valid Mobile Number
												</p>
											)}
										</div>
										<div>
											<label
												htmlFor='email'
												className='d-block text-start c1_c1_label mb-2 mt-4'>
												Email<span className='text-danger '>*</span>
											</label>
											<input
												id='email'
												className='w-100 py-2 c1_c1_input'
												type='email'
												onChange={handleChange}
												name='email'
												placeholder='Enter Your Email ID'
											/>
											{emailErr && (
												<p className='text-danger text-start mb-0 errMsg mt-2'>
													Enter Valid Email
												</p>
											)}
										</div>
										<div className='d-flex  justify-content-center'>
											<button
												className='my-4  w-100 mb-lg-3 mt-4 c1_c1_btn'
												type='submit'>
												File IT Return
											</button>
										</div>
									</div>
								</form>
							</div>
						</Col>
					</Row>
					{service ? (
						<Row>
							<Col sm={12} lg={7}>
								<div className={service ? 'mt-5 pt-lg-5' : 'mt-5 mt-lg-0'}>
									<div>
										<p className=' c1_c1_h1 mb-3 mb-lg-4 text-start'>
											Things To know
										</p>
									</div>
									{datas && <Tabs datas={datas} />}
								</div>
							</Col>
						</Row>
					) : (
						<Row>
							<Col sm={12} md={10} lg={9}>
								<div className={service ? 'mt-5 pt-lg-5' : 'mt-5 mt-lg-0'}>
									<div>
										<p className=' c1_c1_h1 mb-3 mb-lg-4 text-start'>
											Things To know
										</p>
									</div>
									{datas && <Tabs datas={datas} />}
								</div>
							</Col>
						</Row>
					)}
				</>
			)}
			{serviceSuccess && (
				<ServiceSuccess
					isOpen={serviceSuccess}
					onRequestClose={serviceSuccesss}
				/>
			)}
		</div>
	);
}

export default ServiceContent;
